import { demoTheme } from "./theme.config.js";
const assetBase = "/assets/quizzes/demo";
export const demoQuiz = {
    id: "demo-english-marketing",
    slug: "demo",
    version: 3,
    presentation: {
        style: "expressive",
        firstQuestionLayout: "portrait-pair",
        counter: { enabled: true, totalSteps: 5 },
        resultGate: "compact",
        mascot: {
            hero: { type: "image", src: `${assetBase}/mascot/study.webp`, width: 384, height: 384, alt: "", crop: "contain", motion: "float" },
            success: { type: "image", src: `${assetBase}/mascot/success.webp`, width: 384, height: 384, alt: "", crop: "contain", motion: "reveal" }
        }
    },
    metadata: {
        name: "EnglishDom",
        language: "uk",
        description: "Demo branching quiz for an English school campaign."
    },
    startQuestionId: "gender",
    landing: {
        enabled: true,
        sections: [
            {
                type: "benefits",
                title: "Що ти отримаєш за 2 хвилини",
                items: [
                    { title: "Рівень", text: "Побачиш сильні та слабкі сторони без довгих тестів." },
                    { title: "Маршрут", text: "Отримаєш напрям навчання під роботу, подорожі або іспити." },
                    { title: "План", text: "Після заявки відкриється повна персональна рекомендація." }
                ]
            }
        ]
    },
    start: {
        enabled: true,
        renderer: "native",
        mode: "first-question",
        layout: "split-question",
        eyebrow: "Безкоштовний міні-тест",
        title: "Твоя англійська.\nТвій найшвидший прогрес.",
        subtitle: "Знайди формат навчання, що підійде саме тобі.",
        note: "2 хвилини · 5 питань",
        cta: { label: "Почати тест", action: "startQuiz" },
        media: {
            type: "image",
            desktopSrc: `${assetBase}/hero-desktop.svg`,
            mobileSrc: `${assetBase}/hero-mobile.svg`,
            alt: "Student learning English with a bright lesson dashboard"
        },
        background: { type: "color", value: "#4FC87B" },
        logo: { enabled: false }
    },
    progress: {
        mode: "stages",
        stages: [
            { id: "identity", weight: 12 },
            { id: "profile", weight: 18 },
            { id: "goal", weight: 26 },
            { id: "level", weight: 24 },
            { id: "preferences", weight: 20 }
        ]
    },
    phone: {
        defaultCountry: "UA",
        preferredCountries: ["UA", "CZ", "PL", "DE"],
        searchable: true
    },
    questions: [
        {
            id: "gender",
            type: "single-choice",
            stage: "identity",
            title: "Обери стать",
            answers: [
                { id: "woman", label: "Жінка", media: { src: `${assetBase}/answers/woman-v4.webp`, alt: "" }, next: "goal", scores: {} },
                { id: "man", label: "Чоловік", media: { src: `${assetBase}/answers/man-v4.webp`, alt: "" }, next: "goal", scores: {} }
            ]
        },
        {
            id: "goal",
            type: "single-choice",
            stage: "profile",
            title: "Для чого тобі англійська зараз?",
            subtitle: "Обери те, що найближче до твоєї мети.",
            answers: [
                {
                    id: "work",
                    label: "Для роботи та кар'єри",
                    description: "Мітинги, переговори, презентації",
                    media: { src: `${assetBase}/answers/learning-goals.png`, alt: "Work English" },
                    next: "industry",
                    scores: { business: 4, speaking: 1 }
                },
                {
                    id: "travel",
                    label: "Для подорожей і життя за кордоном",
                    description: "Живе спілкування без паніки",
                    media: { src: `${assetBase}/answers/learning-goals.png`, alt: "Travel English" },
                    next: "travel_frequency",
                    scores: { speaking: 4, beginner: 1 }
                },
                {
                    id: "exam",
                    label: "Для іспиту або сертифіката",
                    description: "Структура, дедлайни, бал",
                    media: { src: `${assetBase}/answers/learning-goals.png`, alt: "Exam English" },
                    next: "exam_context",
                    scores: { exam: 5 }
                }
            ]
        },
        {
            id: "industry",
            type: "single-choice",
            stage: "goal",
            title: "У якому робочому контексті англійська потрібна найбільше?",
            answers: [
                { id: "it", label: "IT / продукт / технічні команди", next: "current_level", scores: { business: 3, speaking: 1 } },
                { id: "management", label: "Менеджмент, продажі або переговори", next: "current_level", scores: { business: 4 } },
                { id: "service", label: "Сервіс, підтримка або спілкування з клієнтами", next: "current_level", scores: { speaking: 2, business: 2 } }
            ]
        },
        {
            id: "exam_context",
            type: "single-choice",
            stage: "goal",
            title: "До якого іспиту готуєшся?",
            answers: [
                { id: "international", label: "IELTS, TOEFL або Cambridge", next: "current_level", scores: { exam: 3 } },
                { id: "admission", label: "Вступний або випускний іспит", next: "current_level", scores: { exam: 2, beginner: 1 } },
                { id: "undecided", label: "Ще обираю сертифікат", next: "current_level", scores: { exam: 1, speaking: 1 } }
            ]
        },
        {
            id: "travel_frequency",
            type: "single-choice",
            stage: "goal",
            title: "Як часто плануєш використовувати англійську в подорожах?",
            answers: [
                { id: "soon", label: "Вже найближчими місяцями", next: "current_level", scores: { speaking: 4 } },
                { id: "sometimes", label: "Кілька разів на рік", next: "current_level", scores: { speaking: 3, beginner: 1 } },
                { id: "relocation", label: "Готуюся до переїзду", next: "current_level", scores: { speaking: 4, business: 1 } }
            ]
        },
        {
            id: "current_level",
            type: "single-choice",
            stage: "level",
            title: "Як ти оцінюєш свій рівень?",
            answers: [
                { id: "zero", label: "Починаю майже з нуля", next: "time_budget", scores: { beginner: 6 } },
                { id: "beginner", label: "Можу сказати прості фрази", next: "time_budget", scores: { beginner: 4, speaking: 1 } },
                { id: "intermediate", label: "Говорю, але хочу впевненості", next: "time_budget", scores: { speaking: 3, business: 2 } },
                { id: "advanced", label: "Потрібна точність і професійність", next: "time_budget", scores: { business: 3, exam: 2 } }
            ]
        },
        {
            id: "time_budget",
            type: "single-choice",
            stage: "preferences",
            title: "Скільки часу реально готовий/готова вкладати щотижня?",
            answers: [
                { id: "light", label: "1-2 години", next: "__end__", scores: { beginner: 1, speaking: 1 } },
                { id: "steady", label: "3-4 години", next: "__end__", scores: { speaking: 2, business: 1 } },
                { id: "intensive", label: "5+ годин", next: "__end__", scores: { business: 2, exam: 2 } }
            ]
        }
    ],
    scoring: {
        categories: ["business", "speaking", "beginner", "exam"],
        normalizeTo: 100,
        tieBreaker: ["advanced_business", "conversation_fluency", "exam_ready", "start_from_zero"],
        rules: [
            {
                id: "zero_level_restrict",
                when: { type: "answerEquals", questionId: "current_level", answerId: "zero" },
                effect: { type: "restrict", resultIds: ["start_from_zero"] },
                reason: "zero-level"
            },
            {
                id: "zero_level_override",
                when: { type: "answerEquals", questionId: "current_level", answerId: "zero" },
                effect: { type: "override", resultId: "start_from_zero" },
                reason: "Починати варто з міцної бази, а не з вузької професійної програми."
            },
            {
                id: "management_business_boost",
                when: {
                    type: "all",
                    conditions: [
                        { type: "answerEquals", questionId: "goal", answerId: "work" },
                        { type: "answerEquals", questionId: "industry", answerId: "management" },
                        { type: "answerEquals", questionId: "current_level", answerId: "intermediate" }
                    ]
                },
                effect: { type: "boost", category: "business", value: 4 },
                reason: "work-management-boost"
            },
            {
                id: "exam_intensive_boost",
                when: {
                    type: "all",
                    conditions: [
                        { type: "answerEquals", questionId: "goal", answerId: "exam" },
                        { type: "answerEquals", questionId: "time_budget", answerId: "intensive" }
                    ]
                },
                effect: { type: "boost", category: "exam", value: 5 },
                reason: "exam-intensive"
            },
            {
                id: "travel_conversation_tag",
                when: { type: "answerEquals", questionId: "goal", answerId: "travel" },
                effect: { type: "tag", tag: "travel-speaking" },
                reason: "travel-speaking"
            }
        ]
    },
    results: [
        {
            id: "advanced_business",
            category: "business",
            title: "Business English Sprint",
            shortTitle: "Business",
            description: "Твій маршрут має фокус на роботі: переговори, зустрічі, презентації і точність формулювань.",
            preview: "Почни з діагностики робочих ситуацій і 3-4 практичних сценаріїв на тиждень.",
            gatedContent: "Повний план: 2 тижні розмовного розігріву, 4 тижні робочих сценаріїв, фінальний блок презентацій і дзвінків.",
            scoreLabel: "Відповідність твоїм цілям",
            priority: 4,
            illustration: `${assetBase}/result.svg`
        },
        {
            id: "conversation_fluency",
            category: "speaking",
            title: "Speaking Confidence Track",
            shortTitle: "Speaking",
            description: "Тобі потрібна свобода в живому спілкуванні: менше пауз, більше автоматизму і практики.",
            preview: "Найкраще зайде коротка регулярна розмовна практика з корекцією помилок.",
            gatedContent: "Повний план: daily speaking prompts, рольові діалоги, travel/work ситуації та щотижнева перевірка прогресу.",
            scoreLabel: "Відповідність твоїм цілям",
            priority: 3,
            illustration: `${assetBase}/result.svg`
        },
        {
            id: "start_from_zero",
            category: "beginner",
            title: "Start From Zero",
            shortTitle: "Starter",
            description: "Найкращий результат зараз — не поспішати, а швидко зібрати базу і впевнені перші фрази.",
            preview: "Почни з граматичного фундаменту, вимови і простих діалогів без перевантаження.",
            gatedContent: "Повний план: 10 базових тем, словникові ядра, міні-діалоги, перехід до speaking practice після першого місяця.",
            scoreLabel: "Відповідність твоїм цілям",
            priority: 2,
            illustration: `${assetBase}/result.svg`
        },
        {
            id: "exam_ready",
            category: "exam",
            title: "Exam Ready Plan",
            shortTitle: "Exam",
            description: "Твій маршрут має фокус на структурі, дедлайні і тренуванні формату іспиту.",
            preview: "Потрібен план із вимірюваними mini-mocks, vocabulary blocks і роботою над weak spots.",
            gatedContent: "Повний план: стартовий mock, щотижневі writing/speaking checks, error log і фінальний інтенсив перед іспитом.",
            scoreLabel: "Відповідність твоїм цілям",
            priority: 1,
            illustration: `${assetBase}/result.svg`
        }
    ],
    analysis: {
        visual: {
            type: "image",
            src: `${assetBase}/mascot/study.webp`,
            alt: "",
            width: 256,
            height: 256,
            placement: "heading-leading",
            shape: "free",
            crop: "contain",
            motion: "reveal"
        },
        title: "Формуємо твій персональний результат",
        subtitle: "Твої цілі, досвід і ритм навчання складаються в один маршрут.",
        display: "stage-cards",
        durationMs: 3900,
        reducedMotionDurationMs: 400,
        steps: [
            { id: "answers", title: "Аналізуємо відповіді", description: "Збираємо ціль, рівень і контекст навчання." },
            { id: "matching", title: "Порівнюємо напрямки", description: "Знаходимо формати, які відповідають твоїм цілям." },
            { id: "recommendation", title: "Формуємо рекомендацію", description: "Готуємо персональний маршрут і наступний крок." }
        ],
        checkpoints: [0, 17, 34, 41, 63, 82, 96, 100]
    },
    resultPresentation: {
        visual: {
            type: "image",
            src: `${assetBase}/mascot/result.webp`,
            mobileSrc: `${assetBase}/mascot/result-mobile.webp`,
            alt: "",
            width: 384,
            height: 384,
            placement: "card-overlap-top",
            crop: "contain",
            align: "center",
            size: "medium",
            motion: "reveal"
        }
    },
    leadForm: {
        title: "Куди надіслати повний результат?",
        subtitle: "Отримай послідовність занять і фокус першого тижня під твою ціль.",
        placement: "inline-result",
        fields: {
            name: { enabled: true, required: true, label: "Ім'я" },
            phone: { enabled: true, required: true, label: "Телефон" },
            email: { enabled: true, required: true, label: "Електронна пошта" }
        },
        privacyConsentRequired: true,
        marketingConsentEnabled: true,
        submitLabel: "Отримати повний результат"
    },
    uiCopy: {
        resultEyebrow: "Твої результати готові",
        resultBreakdownTitle: "Твій профіль",
        lockedTitle: "Твій персональний план готовий",
        resultCta: "Отримати повну рекомендацію",
        lockedText: "Заповни форму, щоб відкрити детальний результат і план навчання."
    },
    theme: demoTheme
};
